import { useEffect } from "react";
import { useAtomValue } from "jotai/react";

import { PatientType } from "@/domain/patients";
import { pendingLanguageAtom } from "@/stores/atoms";

import { useAppLanguage } from "./useAppLanguage";

// Applies the stored preferred language to the device on login. setLanguage restarts the
// app, so the caller must keep rendering its loading state while this returns true — the
// UI is never shown in the wrong language. A pending choice wins over the server value.
export const useApplyPreferredLanguage = (patient: PatientType | undefined) => {
  const { language, setLanguage } = useAppLanguage();
  const pendingLanguage = useAtomValue(pendingLanguageAtom);

  const serverLanguage = patient?.preferredLanguage;
  const shouldApplyServerLanguage = Boolean(
    serverLanguage && !pendingLanguage && serverLanguage !== language,
  );

  useEffect(() => {
    if (shouldApplyServerLanguage && serverLanguage) {
      setLanguage(serverLanguage);
    }
  }, [shouldApplyServerLanguage, serverLanguage, setLanguage]);

  return shouldApplyServerLanguage;
};
